import * as React from 'react';
import { Layout, Row, Col, DatePicker, Card, Steps, Button, List } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { KeyValueDisplay } from '../key_value_display/KeyValueDisplay';
import { dateFormatter, optionalFilter } from '../../utils/DataFormatterUtils';
import { Link } from 'react-router-dom';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';
import { ROLES } from '../roles/roles';
import { getProtectedImageUriForSupplier } from '../../utils/FileAccessUtils';
import { InitUser } from '../../thunks/session_thunks';
import { nullSafeGet } from '../../utils/DataAccessUtils';
require('./MySupplierProfilePage.less');

const { Content } = Layout;

class MySupplierProfilePage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = { loading: false };
	}
	componentDidMount() {
		const { fetchUserObj } = this.props;
		fetchUserObj('supplier');
	}

	render() {
		const { currentUser } = this.props;
		const dateFormat = 'MMM D, YYYY';
		const { loading } = this.state;

		const userDetails = {
			Roles: currentUser.roles,
			'Member Since': dateFormatter(currentUser.createdAt, dateFormat),
			Email: currentUser.email,
			'Work Phone': optionalFilter(currentUser.phoneWork),
			'Mobile Phone': optionalFilter(currentUser.phoneMobile),
			Fax: optionalFilter(currentUser.fax),
		};
		const userDetailsRenderFuncs = {
			Roles: (roles) => <div>{roles.map((r) => ROLES[r].displayName).join(', ')}</div>,
		};

		let imgFileId, imgFileName, photoUri;
		if (currentUser.photoLink) {
			[imgFileId, imgFileName] = currentUser.photoLink.split('/');
			photoUri = getProtectedImageUriForSupplier(imgFileId, imgFileName, 'auto', 240);
		}

		return (
			<Content className="supplierProfilePage" style={{ padding: '0 0.5em' }}>
				{loading ? (
					<PageLoadingPlaceholder />
				) : (
					<div>
						<Row style={{ margin: '0.5em 0' }} gutter={16}>
							<Col span={24}>
								<Card>
									<div className="supplierProfilePage__header">
										<div style={{ float: 'left', display: 'flex', alignItems: 'center' }}>
											<div style={{ marginRight: 32 }}>
												<FlexibleImageAvatar
													displayName={currentUser.nameGiven + ' ' + currentUser.nameFamily}
													showPopover={false}
													popoverText={''}
													imageUrl={photoUri}
													width="96px"
													height="96px"
												/>
											</div>
											<div
												style={{
													height: 80,
													display: 'flex',
													flexDirection: 'column',
													justifyContent: 'center',
												}}
											>
												<div style={{ display: 'flex' }}>
													<h4>
														{currentUser.nameGiven} {currentUser.nameFamily}
													</h4>
												</div>
												{nullSafeGet('facility.displayName', currentUser) ? (
													<div style={{ marginBottom: 0, fontSize: 16, display: 'flex' }}>
														{nullSafeGet('facility.displayName', currentUser)}
													</div>
												) : null}
												{nullSafeGet('department', currentUser) &&
												nullSafeGet('title', currentUser) ? (
													<div style={{ marginBottom: 0, fontSize: 16, display: 'flex' }}>
														{nullSafeGet('department', currentUser)},{' '}
														{nullSafeGet('title', currentUser)}
													</div>
												) : null}
											</div>
										</div>
										<div
											style={{
												float: 'right',
												width: '60%',
												display: 'flex',
												justifyContent: 'flex-end',
												maxWidth: 550,
											}}
										>
											<Link to="/supplier/myProfile/edit">
												<Button>Edit Profile</Button>
											</Link>
										</div>
									</div>
								</Card>
							</Col>
						</Row>

						<Row style={{ margin: '0.5em 0' }} gutter={16}>
							<Col span={24}>
								<Card title="Account Details">
									<KeyValueDisplay
										keyValueStore={userDetails}
										renderFuncs={userDetailsRenderFuncs}
									/>
								</Card>
							</Col>
						</Row>
					</div>
				)}
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	fetchUserObj: (userType) => dispatch(InitUser(userType)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(MySupplierProfilePage)
);
